<template>
  <div id="equipmentChart">
    <div id="equipmentChartBox" ref="equipmentChartBox"></div>
  </div>
</template>
<script>
import echarts from "echarts/lib/echarts";
// 引入折线图
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/dataZoom";
export default {
  name: "equipmentChart",
  data() {
    return {
      xData: [],
      setTemps: [],
      envTemps: [],
      maxTemp: 0,
      minTemp: 0,
    };
  },
  props: {
    equipmentData: null,
  },
  created() {
    for (let i = 0; i <= 144; i++) {
      this.xData.push(i);
    }
  },
  mounted() {
    try {
      this.equipmentData.temps.forEach((element) => {
        this.setTemps.push(element.setTemperature);
        this.envTemps.push(element.inDoorTemp);
      });
      this.getMaxAndMinTemp();
      setTimeout(() => {
        this.myChart = echarts.init(this.$refs.equipmentChartBox);
        this.initData();
      }, 500);
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    //获取最大温度和最小温度
    getMaxAndMinTemp() {
      var setTempMax;
      var setTempMin;
      var envTempMax;
      var envTempMin;
      for (let index = 0; index < this.setTemps.length; index++) {
        const element = this.setTemps[index];
        if (element == null) continue;
        if (setTempMax == null || setTempMax < element) setTempMax = element;
        if (setTempMin == null || setTempMin > element) setTempMin = element;
      }
      for (let index = 0; index < this.envTemps.length; index++) {
        const element = this.envTemps[index];
        if (element == null) continue;
        if (envTempMax == null || envTempMax < element) envTempMax = element;
        if (envTempMin == null || envTempMin > element) envTempMin = element;
      }
      var maxValue = setTempMax > envTempMax ? setTempMax : envTempMax;
      var minValue = setTempMin < envTempMin ? setTempMin : envTempMin;
      this.$set(this, "maxTemp", maxValue);
      this.$set(this, "minTemp", minValue);
    },
    initData() {
      var option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            var paramGas = params[0];
            var paramTemp = params[1];
            if (paramGas == undefined || paramTemp == undefined) {
              return "";
            }
            var axisLabel = parseInt(paramGas.axisValue);
            var hour = Math.floor(axisLabel / 6).toString();
            var minutes = ((axisLabel % 6) * 10).toString();
            if (hour.length == 1) {
              hour = "0" + hour;
            }
            if (minutes.length == 1) {
              minutes = "0" + minutes;
            }
            var axisDate = hour + ":" + minutes;
            var gasData = paramGas.data == null ? "-" : paramGas.data;
            var tempData = paramTemp.data == null ? "-" : paramTemp.data;
            return (
              axisDate +
              "</br>" +
              paramGas.marker +
              paramGas.seriesName +
              ": " +
              gasData +
              "</br>" +
              paramTemp.marker +
              paramTemp.seriesName +
              ": " +
              tempData
            );
          },
        },
        legend: {
          top: "0",
          right: "10%",
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          padding: 0,
          itemGap: 5,
          textStyle: {
            color: "#E3EAF3",
            fontSize: 10,
          },
          data: ["设置温度", "室内温度"],
        },
        grid: {
          top: "20%",
          left: "20%",
          right: "10%",
          bottom: "22%",
          containLabel: false,
        },
        textStyle: {
          color: "#E3EAF3",
        },
        xAxis: {
          type: "category",
          data: this.xData,
          name: "时间(h)",
          nameLocation: "start",
          nameTextStyle: {
            fontSize: 10,
            fontWeight: 10,
            align: "center",
            verticalAlign: "top",
            padding: [8, 10, 0, 0],
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            interval: 11,
            textStyle: {
              fontSize: 10,
              fontWeight: 10,
            },
            formatter: function (value, index) {
              return Math.floor(value / 6);
            },
          },
        },
        yAxis: {
          type: "value",
          name: "温度(℃)",
          min: this.minTemp - 1 <= 0 ? 0 : this.minTemp - 1,
          max: this.maxTemp + 1,
          nameTextStyle: {
            fontSize: 10,
            fontWeight: 10,
            align: "right",
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              fontSize: 10,
              fontWeight: 10,
            },
            formatter: "{value}" + " " + "℃",
          },
        },
        dataZoom: [
          {
            type: "inside",
            show: false,
            xAxisIndex: [0],
            height: 1,
            start: 1,
            end: 100,
          },
        ],
        series: [
          {
            name: "设置温度",
            type: "line",
            symbol: "circle",
            itemStyle: {
              color: "#FFFC00",
            },
            lineStyle: {
              color: "#FFFC00",
            },
            data: this.setTemps,
          },
          {
            name: "室内温度",
            type: "line",
            symbol: "circle",
            itemStyle: {
              color: "#4BCEFF",
            },
            lineStyle: {
              color: "#4BCEFF",
            },
            data: this.envTemps,
          },
        ],
      };
      this.myChart.setOption(option);
    },
  },
};
</script>
<style scoped>
#equipmentChart {
  width: 100%;
  height: 100%;
}
#equipmentChartBox {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/subComponents/smartEquipmentChart.vue